<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
  #mainContainer
  [ngClass]="containerClass()"
  [style.--main-container-gap]="MAIN_CONTAINER_GAP + 'px'"
  [style.--legend-height]="LEGEND_HEIGHT + 'px'"
  [style.--am-chart-height]="amChartHeight() + 'px'"
  [style.--tooltip-row-height]="TOOLTIP_ROW_HEIGHT + 'px'"
  [style.--tooltip-container-gap]="TOOLTIP_CONTAINER_GAP + 'px'"
  [style.--time-label-height]="TIME_LABEL_HEIGHT + 'px'"
  [style.--y-axis-width]="(yAxis() ? Y_AXIS_WIDTH : 0) + 'px'"
>
  <div class="title" [class.faded]="cursorPositionOnTimeline()">
    @if (showHideToggle()) {
      <pozi-toggle
        class="toggle"
        [value]="true"
        (valueChange)="closed.emit()"
        [color]="'#8CC814'"
      ></pozi-toggle>
    }
    @if (data().symbol) {
      <i
        class="material-symbols-rounded"
        [style.color]="data().symbol!.color"
        >{{ data().symbol!.symbol }}</i
      >
    }
    <div>
      {{ highlightedLegendItem()?.name ?? data().title ?? 'Timeline' }}
    </div>
    @if (highlightedLegendItem()) {
      @for (summary of highlightedLegendItem()?.summaries; track $index) {
        <strong>{{ summary }}</strong>
      }
    }
  </div>
  <div class="item-container">
    @if (
      showIntervalSummary() && lastSectionEndTime() && firstSectionStartTime()
    ) {
      <div class="interval-summary" [class.faded]="cursorPositionOnTimeline()">
        <span class="interval">
          {{ firstSectionStartTime() | date: 'HH:mm' }} -
          {{ lastSectionEndTime() | date: 'HH:mm' }}
        </span>
        <span class="duration">{{
          lastSectionEndTime()!.getTime() - firstSectionStartTime()!.getTime()
            | intervalHHMM
        }}</span>
      </div>
    }
    <pozi-timeline-chart-legend
      [legendItems]="data().legendItems"
      [hiddenTimelineKeys]="hiddenTimelineKeys()"
      [hiddenAmChartSeriesKeys]="hiddenAmChartSeriesKeys()"
      [isAllItemsHidden]="!!cursorPositionOnTimeline()"
      (legendItemMouseEnter)="onLegendItemMouseEnter($event)"
      (legendItemMouseLeave)="onLegendItemMouseLeave()"
      (legendItemClick)="onLegendItemClick($event)"
    ></pozi-timeline-chart-legend>
    <div
      class="toggle-menu-button"
      [class.faded]="cursorPositionOnTimeline()"
      [style.display]="data().toggleMenu ? 'inherit' : 'none'"
      cdkOverlayOrigin
      #dropdownToggle="cdkOverlayOrigin"
      (click)="toggleMenuDropdown()"
    >
      <i class="material-symbols-rounded">legend_toggle</i>
    </div>
  </div>
  @if (data().amChart) {
    <div
      class="am-chart"
      [style.display]="this.isAmChartDisplayed() ? 'flex' : 'none'"
    >
      <div
        [id]="chartUuid"
        #amChartContainer
        [style.height.px]="amChartHeight()"
        [style.width.%]="100"
        (mousemove)="onAmChartMouseMove($event)"
        (pointerout)="cursorPositionOnTimeline.set(null)"
      ></div>
      @if (yAxis()) {
        <div class="y-axis" [style.height.px]="amChartHeight()">
          <span class="y-axis-label"
            >{{ yAxisTopValue() }}{{ yAxisUnitSuffix() }}</span
          >
          <span class="y-axis-label"
            >{{ yAxisMiddleValue() }}{{ yAxisUnitSuffix() }}</span
          >
          <span class="y-axis-label">0{{ yAxisUnitSuffix() }}</span>
        </div>
      }
    </div>
  }
  @if (isTimelinePresent()) {
    <div
      class="timeline"
      #timelineContainer
      (mousemove)="onTimelineMouseMove($event)"
      (mouseleave)="cursorPositionOnTimeline.set(null)"
    >
      @for (timeline of displayedTimelines(); track $index) {
        <div
          class="parent-row"
          [style.margin-bottom.px]="getTimelineMargin($index, $last)"
          [class.margin-for-pins]="timeline.pins && timeline.pins.length > 0"
          [style.height.px]="timeline.height ?? DEFAULT_SECTION_HEIGHT"
          [style.gap.px]="timeline.gap ?? DEFAULT_TIMELINE_GAP"
        >
          @for (section of timeline.timelineSections; track section.uuid) {
            <div
              class="section"
              [style.left]="getRelativePosition(section.startTime!, 0)"
              [style.top.px]="
                $index * -(timeline.height ?? DEFAULT_SECTION_HEIGHT)
              "
              [style.background-color]="
                section.color ??
                (section.key && legendKeyColorMap().get(section.key)) ??
                DEFAULT_SECTION_COLOR
              "
              [style.width]="
                getSectionWidthCssValue(section.ratio!, timeline.gap)
              "
              [class.faded]="
                timeline.isExcludedFromHighlightFade
                  ? false
                  : isFaded(section.key)
              "
              [style.height.px]="timeline.height ?? DEFAULT_SECTION_HEIGHT"
            >
              @if (section.name) {
                <span class="section-name">{{ section.name }}</span>
              }
            </div>
          }
          @for (pin of timeline.pins; track pin) {
            <div
              class="pin"
              [style.left]="getRelativePosition(pin.time, 16)"
              [routerLink]="pin.link"
              [style.cursor]="pin.link ? 'pointer' : 'inherit'"
            >
              <i class="material-symbols-rounded" [style.color]="pin.color">{{
                pin.symbol
              }}</i>
            </div>
          }
        </div>
      }
    </div>
  }
  @if (cursorPositionOnTimeline()) {
    <div
      class="seeker"
      [style.left.px]="cursorPositionOnTimeline()!.offsetX"
      [style.height.px]="tooltipSeekerHeight()"
    ></div>
    <div
      class="seeker seeker-aura"
      [style.left.px]="cursorPositionOnTimeline()!.offsetX - 2"
      [style.height.px]="tooltipSeekerAuraHeight()"
    ></div>
    @if (displayedTooltips().length > 0) {
      <div class="tooltip-container" [ngStyle]="tooltipContainerStyle()">
        @for (tooltip of displayedTooltips(); track $index) {
          <div class="tooltip-row">
            @switch (tooltip.icon.symbol) {
              @case ('bar') {
                <div
                  class="bar-icon"
                  [style.background-color]="tooltip.icon.color"
                ></div>
              }
              @case ('line') {
                <div
                  class="line-icon"
                  [style.background-color]="tooltip.icon.color"
                ></div>
              }
              @case ('speed') {
                <div class="svg-icon-container">
                  <img src="assets/img/speed_simple.svg" alt="speed" />
                </div>
              }
              @default {
                <i
                  class="material-symbols-rounded"
                  [style.color]="tooltip.icon.color"
                  >{{ tooltip.icon.symbol }}</i
                >
              }
            }
            @for (value of tooltip.values; track $index) {
              <span class="tooltip" [innerHTML]="value"></span>
            }
          </div>
        }
      </div>
    }
  }
  @if (!hideTimes() || (hideTimes() && cursorPositionOnTimeline())) {
    <div class="time">
      @for (time of staticTimeLabels(); track time) {
        <span
          class="time-label"
          [class.faded]="cursorPositionOnTimeline()"
          [class.gray]="isTimeLabelGray(time)"
          [style.left]="
            getRelativePosition(
              time!,
              areDayLabelsDisplayed()
                ? timelineChartService.getOffSetForTimeLabel(0, false, false)
                : timelineChartService.getOffSetForTimeLabel(15, $first, $last)
            )
          "
          >{{ time | date: (areDayLabelsDisplayed() ? 'd' : 'HH:mm') }}</span
        >
      }
      @if (cursorPositionOnTimeline()) {
        <span
          class="time-label highlighted-time-label"
          [style.left]="
            getRelativePosition(
              dateOnCursor()!,
              timelineChartService.getOffSetForTimeLabel(
                cursorPositionOnTimeline()!.percentage < 50
                  ? -9
                  : areDayLabelsDisplayed()
                    ? 94
                    : 54,
                false,
                false
              )
            )
          "
          >{{
            dateOnCursor()
              | date: (areDayLabelsDisplayed() ? 'MM.dd HH:mm' : 'HH:mm')
          }}</span
        >
      }
    </div>
  }
</div>

<ng-template
  cdkConnectedOverlay
  #overlay="cdkConnectedOverlay"
  [cdkConnectedOverlayOrigin]="dropdownToggle"
  [cdkConnectedOverlayOpen]="isToggleMenuDropDownOpen()"
  (overlayOutsideClick)="isToggleMenuDropDownOpen.set(false)"
  [cdkConnectedOverlayPanelClass]="'cdk-dropdown'"
  [cdkConnectedOverlayPositions]="ToggleMenuCdkOverlayPositionPairs"
>
  <div class="dropdown-content">
    <ul class="item-list">
      @for (timelineChartToggle of data().toggleMenu; track $index) {
        <li (click)="onTimelineChartToggleClick(timelineChartToggle)">
          @if (isToggleActive(timelineChartToggle)) {
            <i class="material-symbols-rounded">done</i>
          } @else {
            <span class="check-placeholder"></span>
          }
          {{ timelineChartToggle.name }}
        </li>
      }
    </ul>
  </div>
</ng-template>
